export default __webpack_public_path__ + "static/media/Chestguard of the Tormentor.be11246b.jpg";